import { useState } from "react";
import { Box, Button, TextField, Typography, Paper } from "@mui/material";
import { useAuth } from "./AuthContext";
import { getStoredToken } from "./authStorage";

const ChangePassword = () => {
  const { handleAuthError } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [verifyNewPassword, setVerifyNewPassword] = useState("");
  const [status, setStatus] = useState(null);

  const handleChangePassword = async (e) => {
    e.preventDefault();

    try {
      if (newPassword !== verifyNewPassword) {
        return setStatus("Passwords do not match.");
      }
      const res = await fetch(`${process.env.REACT_APP_AUTH_API_URL}/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getStoredToken()}`,
        },
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      const data = await res.json();
      if (res.status === 401) {
        handleAuthError(data.message || "Your session expired. Please log in again.");
        return;
      }

      setStatus(data.message || "Success");
    } catch (err) {
      console.error(err);
      setStatus("Error changing password.");
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Paper sx={{ maxWidth: 400, p: 3, mx: "auto", background: "#1c2023" }}>
        <Typography variant="h6" sx={{ color: "#ff6600", mb: 2 }}>
          Change Password
        </Typography>

        <form onSubmit={handleChangePassword}>
          <TextField
            fullWidth
            type="password"
            label="Current Password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            margin="normal"
            InputProps={{ style: { color: "#fff" } }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />
          <TextField
            fullWidth
            type="password"
            label="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            margin="normal"
            InputProps={{ style: { color: "#fff" } }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />
          <TextField
            fullWidth
            type="password"
            label="Retype Password"
            value={verifyNewPassword}
            onChange={(e) => setVerifyNewPassword(e.target.value)}
            margin="normal"
            InputProps={{ style: { color: "#fff" } }}
            InputLabelProps={{ style: { color: "#aaa" } }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#ff6600" }}
          >
            Update Password
          </Button>

          {status && (
            <Typography sx={{ mt: 2, color: "#aaa" }}>{status}</Typography>
          )}
        </form>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Back to dashboard button */}
          <Button
            variant="outlined"
            href="/dashboard"
            sx={{
              borderColor: "#ff6600",
              color: "#ff6600",
              "&:hover": {
                backgroundColor: "#ff6600",
                color: "#000",
              },
              mt: 2,
              mr: 2,
            }}
          >
            Back to Dashboard
          </Button>
          
          {/* Bullet library button */}
          <Button
            variant="outlined"
            href="/"
            sx={{
              borderColor: "#ff6600",
              color: "#ff6600",
              '&:hover': {
                backgroundColor: "#ff6600",
                color: "#000",
              },
              mt: 2,
            }}
          >
            Bullet Library
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ChangePassword;
